import React from 'react';
import './ProximityLegend.css';

const ProximityLegend: React.FC = () => {
  return (
    <div className="proximity-legend">
      <div className="legend-header">DISTANCE TO CAMERAS</div>
      <div className="legend-items">
        <div className="legend-item">
          <div className="legend-color distance-very-close"></div>
          <div className="legend-label">Very Close (≤ 500 ft)</div>
        </div>
        <div className="legend-item">
          <div className="legend-color distance-close"></div>
          <div className="legend-label">Close (≤ 250 ft)</div>
        </div>
        <div className="legend-item">
          <div className="legend-color distance-medium"></div>
          <div className="legend-label">Medium (≤ 2000 ft)</div>
        </div>
        <div className="legend-item">
          <div className="legend-color distance-far"></div>
          <div className="legend-label">Far ({'>'}2000 ft)</div>
        </div>
      </div>
    </div>
  );
};

export default ProximityLegend; 